import { render, staticRenderFns } from "./approveItem.vue?vue&type=template&id=4baa72b5&scoped=true&"
import script from "./approveItem.vue?vue&type=script&lang=js&"
export * from "./approveItem.vue?vue&type=script&lang=js&"
import style0 from "./approveItem.vue?vue&type=style&index=0&id=4baa72b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baa72b5",
  null
  
)

export default component.exports